import Vue from 'vue';
import { keyBy } from 'lodash';
import types from './mutation-types';

const mutations = {
  [types.SET_SELECTED_CARD_FOR_NEW_ASMT](state, card) {
    Vue.set(state, 'selectedCardForNewAssignment', card);
  },

  [types.SET_SELECTED](state, assignmentId) {
    Vue.set(state, 'selectedAssignmentId', assignmentId);
  },

  [types.SET_PROPERTY](state, { id, property, value }) {
    Vue.set(state.assignments[id], property, value);
  },

  [types.SET_ASSIGNMENT_STATS](state, teacherAssignmentStats) {
    Vue.set(state, 'teacherAssignmentStats', teacherAssignmentStats);
  },

  [types.SET_ASSIGNMENTS](state, assignmentList) {
    Vue.set(state, 'assignments', keyBy(assignmentList, 'id'));
  },

  [types.ADD_ASSIGNMENTS](state, assignmentList) {
    Vue.set(state, 'assignments', {
      ...state.assignments,
      ...keyBy(assignmentList, 'id'),
    });
  },

  [types.REMOVE_ASSIGNMENT](state, assignmentId) {
    Vue.delete(state.assignments, assignmentId);
  },

  [types.ADD_ASSIGNMENT](state, asmt) {
    Vue.set(state.assignments, asmt.id, asmt);
  },

  [types.UPDATE_ASSIGNMENT](state, asmt) {
    if (state.assignments[asmt.id]) {
      Vue.set(state.assignments, asmt.id, asmt);
    }
  },

  [types.SET_CARD_PAGES](state, { assignmentId, pageList }) {
    if (state.assignments[assignmentId]) {
      const assignedCard = state.assignments[assignmentId].assigned_card;

      if (assignedCard) {
        Vue.set(assignedCard, 'pages', pageList);
      }
    }
  },
};

export default mutations;



// WEBPACK FOOTER //
// ./src/app/assignments/store/mutations.js